"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESPONSE_LIST_SSH_USERS = exports.RESPONSE_ADD_OR_UPDATE_SSH_USER = exports.REQUEST_LIST_SSH_USERS = exports.REQUEST_ADD_OR_UPDATE_SSH_USER = void 0;
var _messageModel = require("../../messageModel");
var SSH_USER = 2025;
var REQUEST_LIST_SSH_USERS = exports.REQUEST_LIST_SSH_USERS = new _messageModel.RequestMessageDefinition(SSH_USER, 0);
var REQUEST_ADD_OR_UPDATE_SSH_USER = exports.REQUEST_ADD_OR_UPDATE_SSH_USER = new _messageModel.RequestMessageDefinition(SSH_USER, 1);
var RESPONSE_LIST_SSH_USERS = exports.RESPONSE_LIST_SSH_USERS = new _messageModel.RespondMessageDefinition(SSH_USER, 0);
var RESPONSE_ADD_OR_UPDATE_SSH_USER = exports.RESPONSE_ADD_OR_UPDATE_SSH_USER = new _messageModel.RespondMessageDefinition(SSH_USER, 1);